import { render, staticRenderFns } from "./UserAvatarGroup.vue?vue&type=template&id=46a3228a&"
import script from "./UserAvatarGroup.vue?vue&type=script&lang=ts&"
export * from "./UserAvatarGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports